import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import PoolServicePage from "@/pages/PoolServicePage";
import PoolRepairsPage from "@/pages/PoolRepairsPage";
import StartupsPage from "@/pages/StartupsPage";
import VacationRentalPage from "@/pages/VacationRentalPage";
import CommercialPage from "@/pages/CommercialPage";
import ServiceAreasPage from "@/pages/ServiceAreasPage";
import LocationPage from "@/pages/LocationPage";
import TierraVerdePage from "@/pages/TierraVerdePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pool-service" element={<PoolServicePage />} />
            <Route path="/pool-repairs" element={<PoolRepairsPage />} />
            <Route path="/pool-startups" element={<StartupsPage />} />
            <Route path="/vacation-rental-pool-service" element={<VacationRentalPage />} />
            <Route path="/commercial-pool-service" element={<CommercialPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:slug" element={<LocationPage />} />
            <Route path="/service-areas/tierra-verde-fl" element={<TierraVerdePage />} />
            <Route path="/tv" element={<Navigate to="/service-areas/tierra-verde-fl/?utm_source=mailshark&utm_medium=direct_mail&utm_campaign=33715_pool_service" replace />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
